const browserUtils = {
  /* 是否是ie浏览器 */
  isIE: function () {
    let doc = document.documentElement
    if (doc) {
      let style = doc.style
      return '-ms-scroll-limit' in style && '-ms-ime-align' in style
    }
  }
}

export default browserUtils
